// This file was automatically generated by the Soy compiler.
// Please don't edit this file by hand.
// source: src/com/yext/storm-common/app/views/common/searchableList.soy

/**
 * @fileoverview Templates in namespace yext.storm.common.searchableList.
 * @public
 */

goog.provide('yext.storm.common.searchableList');
goog.require("yext");

goog.require('goog.soy');
goog.require('soy');
goog.require('soydata.VERY_UNSAFE');


/**
 * @param {?yext.storm.common.searchableList.list.Params=} opt_data
 * @param {(?goog.soy.IjData|?Object<string, *>)=} opt_ijData
 * @return {!goog.soy.data.SanitizedHtml}
 * @suppress {checkTypes}
 */
yext.storm.common.searchableList.list = function(opt_data, opt_ijData) {
  opt_ijData = /** @type {!goog.soy.IjData} */ (opt_ijData);
  opt_data = opt_data || {};
  /** @type {?} */
  const maxLength = opt_data.maxLength;
  /** @type {?} */
  const placeholder = opt_data.placeholder;
  return soydata.VERY_UNSAFE.ordainSanitizedHtml('<div class="js-searchable-list searchable-list"' + (goog.DEBUG && soy.$$debugSoyTemplateInfo ? ' data-debug-soy="yext.storm.common.searchableList.list src/com/yext/storm-common/app/views/common/searchableList.soy:6"' : '') + '><div class="searcher js-searchable-list-input-container"><input class="js-searchable-list-input" type="text" maxlength="' + soy.$$escapeHtmlAttribute(maxLength != null ? maxLength : 20) + '"' + (placeholder ? ' placeholder="' + soy.$$escapeHtmlAttribute(placeholder) + '"' : '') + '><i class="js-searcher-icon searcher-icon"></i></div><ul class="js-scrollable-list scrollable-list sidebar-filter">' + yext.storm.common.searchableList.listItem(/** @type {?} */ (opt_data), opt_ijData) + '</ul></div>');
};
/**
 * @typedef {{
 *  maxLength: (?|undefined),
 *  placeholder: (?|undefined),
 *  id: (?|undefined),
 *  name: (?|undefined),
 *  count: (?|undefined),
 *  showDropdown: (?|undefined),
 *  additionalClass: (?|undefined),
 * }}
 */
yext.storm.common.searchableList.list.Params;
if (goog.DEBUG) {
  /** @type {string} */
  yext.storm.common.searchableList.list.soyTemplateName = 'yext.storm.common.searchableList.list';
}


/**
 * @param {!yext.storm.common.searchableList.dropdown.Params} opt_data
 * @param {(?goog.soy.IjData|?Object<string, *>)=} opt_ijData
 * @return {!goog.soy.data.SanitizedHtml}
 * @suppress {checkTypes}
 */
yext.storm.common.searchableList.dropdown = function(opt_data, opt_ijData) {
  opt_ijData = /** @type {!goog.soy.IjData} */ (opt_ijData);
  /** @type {?} */
  const dropdownRename = opt_data.dropdownRename;
  /** @type {?} */
  const dropdownDelete = opt_data.dropdownDelete;
  return soydata.VERY_UNSAFE.ordainSanitizedHtml('<ul id="searchablelist-options-dropdown" style="display: none;" tabindex="0"' + (goog.DEBUG && soy.$$debugSoyTemplateInfo ? ' data-debug-soy="yext.storm.common.searchableList.dropdown src/com/yext/storm-common/app/views/common/searchableList.soy:23"' : '') + '><li data-option="rename" tabindex="0">' + soy.$$escapeHtml(dropdownRename) + '</li><li data-option="delete" tabindex="0">' + soy.$$escapeHtml(dropdownDelete) + '</li></ul>');
};
/**
 * @typedef {{
 *  dropdownRename: ?,
 *  dropdownDelete: ?,
 * }}
 */
yext.storm.common.searchableList.dropdown.Params;
if (goog.DEBUG) {
  /** @type {string} */
  yext.storm.common.searchableList.dropdown.soyTemplateName = 'yext.storm.common.searchableList.dropdown';
}


/**
 * @param {!yext.storm.common.searchableList.listItem.Params} opt_data
 * @param {(?goog.soy.IjData|?Object<string, *>)=} opt_ijData
 * @return {!goog.soy.data.SanitizedHtml}
 * @suppress {checkTypes}
 */
yext.storm.common.searchableList.listItem = function(opt_data, opt_ijData) {
  opt_ijData = /** @type {!goog.soy.IjData} */ (opt_ijData);
  /** @type {?} */
  const id = opt_data.id;
  /** @type {?} */
  const name = opt_data.name;
  /** @type {?} */
  const count = opt_data.count;
  /** @type {?} */
  const showDropdown = opt_data.showDropdown;
  /** @type {?} */
  const additionalClass = opt_data.additionalClass;
  return soydata.VERY_UNSAFE.ordainSanitizedHtml('<li class="js-searchable-list-item searchable-list-item ' + soy.$$escapeHtmlAttribute(additionalClass != null ? additionalClass : '') + '"' + (!soy.$$equals(id, null) ? ' data-typeid="' + soy.$$escapeHtmlAttribute(id) + '"' : '') + (name ? ' data-text="' + soy.$$escapeHtmlAttribute(name) + '"' : '') + (count ? ' data-count="' + soy.$$escapeHtmlAttribute(count) + '"' : '') + ' tabindex="0"' + (goog.DEBUG && soy.$$debugSoyTemplateInfo ? ' data-debug-soy="yext.storm.common.searchableList.listItem src/com/yext/storm-common/app/views/common/searchableList.soy:35"' : '') + '><span class="js-item-name">' + soy.$$escapeHtml(name != null ? name : '') + '</span><span class="count">' + (!soy.$$equals(count, null) ? '(' + soy.$$escapeHtml(count) + ')' : '') + '</span>' + (soy.$$coerceToBoolean(showDropdown) && (soy.$$equals(id, null) || !id == 0) ? '<button class="down-arrow js-dropdown-icon dropdown-icon"></button>' : '') + '</li>');
};
/**
 * @typedef {{
 *  id: ?,
 *  name: ?,
 *  count: ?,
 *  showDropdown: ?,
 *  additionalClass: ?,
 * }}
 */
yext.storm.common.searchableList.listItem.Params;
if (goog.DEBUG) {
  /** @type {string} */
  yext.storm.common.searchableList.listItem.soyTemplateName = 'yext.storm.common.searchableList.listItem';
}
